<ax-icon
  *ngIf="showIcon"
  class="icon type-icon"
  [name]="customIcon ? customIcon : 'custom:chip'"
></ax-icon>
<ax-chips-edit
  [form]="form"
  [label]="label"
  [autocompleteValues]="labels"
  [required]="required"
  [hint]="hint"
  [errorsTemplate]="errorsTemplate"
  [readonly]="readonly"
  [subscriptSizing]="subscriptSizing"
></ax-chips-edit>

<ng-template #errorsTemplate>
  <ax-property-error [form]="form" [label]="label"></ax-property-error>
</ng-template>
